
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Punetoashtavinayakcabservice() {



    const cardData =
    {
        keyword: 'Pune to Ashtavinayak Cab Service',
        heading: 'S9 Travels: Pune to Ashtavinayak Cab Service',
        headingDescription: 'S9 Travels offers reliable, comfortable, and affordable cab services for your journey from Pune to the Ashtavinayak temples, a renowned pilgrimage circuit in Maharashtra. The Ashtavinayak refers to the eight sacred temples dedicated to Lord Ganesha, located in different parts of the state. These temples are significant in Hindu culture, and a trip to all eight forms of Lord Ganesha is considered highly auspicious.',

        top: 'Top Ashtavinayak Temples to Visit with S9 Travels',

"topPlaces": [
    {
      "title": "Moreshwar Temple (Morgaon)",
      "description": "The Moreshwar Temple in Morgaon is the first and most important temple in the Ashtavinayak circuit. It is dedicated to Lord Ganesha in his Moreshwar (Peacock) form. The temple is located near the town of Morgaon, approximately 55 km from Pune, and is the starting point of the Ashtavinayak pilgrimage."
    },
    {
      "title": "Siddhivinayak Temple (Siddhatek)",
      "description": "The Siddhivinayak Temple in Siddhatek is the second temple in the circuit. It is situated on the banks of the Bhima River and is dedicated to Lord Ganesha in his Siddhi Vinayak (Lord of Success) form. This temple is known for its spiritual significance and the peaceful surroundings."
    },
    {
      "title": "Ballaleshwar Temple (Pali)",
      "description": "The Ballaleshwar Temple in Pali is the third temple on the Ashtavinayak route. It is dedicated to Lord Ganesha in the form of Ballaleshwar and is located in the town of Pali, about 125 km from Pune. The temple is surrounded by lush greenery and provides a serene environment for spiritual reflection."
    },
    {
      "title": "Varadvinayak Temple (Mahad)",
      "description": "The Varadvinayak Temple in Mahad is the fourth temple in the Ashtavinayak circuit. It is dedicated to Lord Ganesha in his Varadvinayak (Lord of Blessings) form and is located around 80 km from Pune. The temple is well-known for its divine atmosphere and beautiful architecture."
    },
    {
      "title": "Chintamani Temple (Theur)",
      "description": "The Chintamani Temple in Theur is the fifth temple in the Ashtavinayak circuit. The temple is dedicated to Lord Ganesha in his Chintamani (Remover of Obstacles) form. It is situated around 30 km from Pune and is famous for its ancient heritage and stunning architecture."
    },
    {
      "title": "Girijatmaj Temple (Lenyadri)",
      "description": "The Girijatmaj Temple in Lenyadri is the sixth temple in the Ashtavinayak circuit. The temple is dedicated to Lord Ganesha in the Girijatmaj (Son of Parvati) form and is located on a hilltop, around 97 km from Pune. The temple provides stunning views of the surrounding landscapes and is a great spot for spiritual reflection."
    },
    {
      "title": "Vigneshwar Temple (Ozar)",
      "description": "The Vigneshwar Temple in Ozar is the seventh temple in the Ashtavinayak circuit. Dedicated to Lord Ganesha in his Vigneshwar (Remover of Obstacles) form, this temple is situated near the town of Ozar, around 90 km from Pune. The peaceful surroundings and historical significance make this temple a must-visit."
    },
    {
      "title": "Mahaganapati Temple (Ranjangaon)",
      "description": "The Mahaganapati Temple in Ranjangaon is the eighth and final temple in the Ashtavinayak circuit. It is dedicated to Lord Ganesha in his Mahaganapati (Great Lord) form and is located about 60 km from Pune. This temple is known for its magnificent architecture and is a significant pilgrimage site."
    }
],

"services": [
    {
      "name": "Book Pune to Ashtavinayak Taxi",
      "description": "Planning a visit to the sacred Ashtavinayak temples from Pune? S9 Travels offers comfortable and reliable taxi services to take you on a smooth journey to all the eight revered temples. Whether you're traveling alone or in a group, we have a range of taxis to suit your needs. Book your Pune to Ashtavinayak taxi today and enjoy a hassle-free experience!"
    },
    {
      "name": "Book Pune to Ashtavinayak Cab Service",
      "description": "For a safe and comfortable trip from Pune to Ashtavinayak, S9 Travels provides top-notch cab services. Our professional drivers will ensure that your journey to the Ashtavinayak temples is smooth and efficient. With a fleet of well-maintained vehicles, we are here to make your pilgrimage or trip as comfortable as possible."
    },
    {
      "name": "Book Pune to Ashtavinayak One-Way Taxi",
      "description": "If you’re looking for a one-way taxi from Pune to Ashtavinayak, S9 Travels has affordable and convenient options. Choose our one-way taxi service for a quick and direct ride to your destination. With easy online booking, we guarantee a comfortable and stress-free journey."
    },
    {
      "name": "Book Pune to Ashtavinayak Round Trip",
      "description": "For a more flexible trip, S9 Travels offers round trip taxi services from Pune to Ashtavinayak. Our round-trip service ensures that you can visit all the eight temples and return to Pune at your convenience. Enjoy a safe, timely, and comfortable trip, knowing you have a professional driver taking care of the route and schedule."
    },
    {
      "name": "Book Pune to Ashtavinayak Taxi Fare",
      "description": "At S9 Travels, we offer affordable pricing for your Pune to Ashtavinayak taxi journey. Our taxi fare is transparent and based on the vehicle type, trip duration, and distance. Contact us for a detailed estimate and to learn about any special discounts or offers available for your trip to the Ashtavinayak temples."
    },
    {
      "name": "Book Pune to Ashtavinayak Car Rental",
      "description": "For those who prefer flexibility, S9 Travels offers car rental services to Ashtavinayak from Pune. Choose from our fleet of well-maintained cars to travel at your own pace and explore each temple. Our car rental service allows you to design your itinerary and make stops as you please."
    },
    {
      "name": "Book Pune to Ashtavinayak Luxury Taxi",
      "description": "If you prefer a more luxurious travel experience, S9 Travels provides luxury taxi services from Pune to Ashtavinayak. Travel in comfort and style with our high-end vehicles equipped with modern amenities. Whether you're traveling for a spiritual journey or simply seeking comfort, our luxury taxi service ensures a memorable experience."
    },
    {
      "name": "Book Pune to Ashtavinayak Efficient Taxi",
      "description": "For an affordable option, S9 Travels offers Efficient Taxi services to Ashtavinayak. Share the ride with fellow travelers and reduce the cost of your journey. Our Efficient Taxis provide a comfortable and budget-friendly solution for those seeking a communal travel experience."
    },
    {
      "name": "Affordable Ashtavinayak Taxi from Pune",
      "description": "At S9 Travels, we strive to provide affordable taxi services to Ashtavinayak from Pune. We offer competitive rates without compromising on comfort and quality. Whether you are booking for a single traveler or a group, our affordable taxis ensure a cost-effective and smooth journey to the Ashtavinayak temples."
    },
    {
      "name": "Private Ashtavinayak Cab from Pune",
      "description": "For those who prefer privacy and flexibility, S9 Travels offers private cabs for your journey from Pune to Ashtavinayak. Our private cabs allow you to enjoy a personalized experience, ensuring you have a peaceful journey. With a dedicated driver, you can visit the temples at your own pace without worrying about time constraints."
    },
    {
      "name": "Ashtavinayak Temple Tour from Pune",
      "description": "Looking to explore the Ashtavinayak temples? S9 Travels offers special temple tour services from Pune to Ashtavinayak. Our drivers are well-versed in the route and can guide you to all the temples efficiently. The tour can be customized to match your schedule and preferences, making it an enriching experience."
    },
    {
      "name": "Ashtavinayak Yatra Cab Service",
      "description": "If you're embarking on the Ashtavinayak Yatra, S9 Travels provides dedicated yatra cab services. Our cabs are designed to offer comfort and convenience during your spiritual journey. We ensure timely pickups, smooth rides, and professional drivers who know the best routes for an uninterrupted yatra experience."
    },
    {
      "name": "Pune to Ashtavinayak Taxi Booking",
      "description": "Booking a taxi from Pune to Ashtavinayak has never been easier with S9 Travels. We offer simple and quick online booking for your Ashtavinayak trip. Choose the vehicle that suits your needs, and our drivers will be ready to take you to your destination safely and comfortably."
    },
    {
      "name": "Ashtavinayak Trip Package from Pune",
      "description": "For a complete and hassle-free experience, S9 Travels offers Ashtavinayak trip packages from Pune. These packages cover transportation, temple visits, and much more, ensuring that your trip is smooth and well-organized. Our expert team takes care of all the details so you can focus on your spiritual journey."
    },
    {
      "name": "Group Travel to Ashtavinayak",
      "description": "If you’re traveling with a group, S9 Travels offers group travel services to Ashtavinayak from Pune. We have vehicles that can accommodate larger groups comfortably, making it ideal for family trips, religious tours, or corporate outings. Contact us for group bookings and enjoy discounts and a coordinated travel experience."
    }
  ],

"tableData": [
  ["Book Pune To Ashtavinayak Taxi", "Book Pune To Ashtavinayak Cab Service"],
  ["Book Pune To Ashtavinayak One-Way Taxi", "Book Pune To Ashtavinayak Round Trip"],
  ["Book Pune To Ashtavinayak Taxi Fare", "Book Pune To Ashtavinayak Car Rental"],
  ["Book Pune To Ashtavinayak Luxury Taxi", "Book Pune To Ashtavinayak Efficient Taxi"],
  ["Affordable Ashtavinayak Taxi from Pune", "Private Ashtavinayak Cab from Pune"],
  ["Ashtavinayak Temple Tour from Pune", "Ashtavinayak Yatra Cab Service"],
  ["Pune to Ashtavinayak Taxi Booking", "Ashtavinayak Trip Package from Pune"],
  ["Group Travel to Ashtavinayak", ""]
],
"whychoose": [
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "At S9 Travels, we understand the significance of time when embarking on your pilgrimage to the Ashtavinayak temples. Our drivers ensure timely pickups and drop-offs, so you can enjoy a smooth and stress-free journey across all the eight temples without any delays."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Vehicles",
    "WhyChoosedescription": "We offer a wide range of well-maintained vehicles, including sedans, SUVs, and premium cars, to ensure your journey from Pune to Ashtavinayak is as comfortable as possible. With air conditioning, spacious seating, and comfortable interiors, our vehicles are perfect for a long-distance religious trip."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our drivers are highly experienced and know the best routes to each of the Ashtavinayak temples. They are committed to ensuring a safe, smooth, and pleasant journey, making your pilgrimage or leisure trip more enjoyable."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "S9 Travels offers affordable and competitive pricing for your Pune to Ashtavinayak trip. We provide a clear breakdown of costs with no hidden charges, so you know exactly what to expect and can plan your budget accordingly."
  },
  {
    "WhyChooseheading": "Safe and Comfortable Journey",
    "WhyChoosedescription": "Your safety is our priority. All our vehicles are equipped with modern safety features such as airbags, seat belts, and GPS tracking. This ensures you a secure and comfortable ride throughout the journey to Ashtavinayak."
  },
  {
    "WhyChooseheading": "24/7 Availability",
    "WhyChoosedescription": "Whether you're planning an early morning trip to visit the temples or a late-night return, S9 Travels is available 24/7. Our customer service team is always ready to assist you with bookings, inquiries, or any other travel-related assistance."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Booking a cab for your Pune to Ashtavinayak trip is easy and convenient. You can book online through our website or mobile app, or simply contact our customer service team for personalized assistance with your booking."
  },
  {
    "WhyChooseheading": "Customized Travel Packages",
    "WhyChoosedescription": "Whether you're visiting Ashtavinayak for religious reasons or for a leisure trip, we offer customized travel packages to suit your preferences. Let us know your requirements, and we will make your trip unique and memorable."
  }
]
























    }



    const faqData = [
        [
          {
            question: 'How can I book a Pune to Ashtavinayak cab with S9 Travels?',
            answer: 'Booking a cab is simple! You can book online through our website or app, or you can contact our customer service team for personalized assistance with your booking.',
          },
          {
            question: 'What types of vehicles are available for the Pune to Ashtavinayak trip?',
            answer: 'We offer a variety of vehicles, including sedans, SUVs, and premium cars. All our vehicles are well-maintained and designed to provide maximum comfort for your long-distance trip.',
          },
          {
            question: 'Are the drivers experienced for long-distance travel to Ashtavinayak?',
            answer: 'Yes, our drivers are experienced in long-distance travel and are familiar with the routes to the Ashtavinayak temples. They ensure a safe and smooth journey, making your trip comfortable and hassle-free.',
          },
          {
            question: 'How do I pay for my Pune to Ashtavinayak cab rental?',
            answer: 'We offer several payment options, including cash, credit/debit cards, and online payments via our app for your convenience.',
          },
          {
            question: 'Can I book a round-trip from Pune to Ashtavinayak?',
            answer: 'Yes, we can arrange a round-trip for you. Simply provide us with your return details, and we will ensure that your return journey from the Ashtavinayak temples is as smooth as the onward trip.',
          },
          {
            question: 'Are there any extra charges for waiting or detours during the trip?',
            answer: 'Any additional charges, such as waiting time or detours, will be communicated to you upfront, ensuring full transparency in pricing.',
          },
          {
            question: 'Can I hire a cab for sightseeing at the Ashtavinayak temples?',
            answer: 'Yes, we offer sightseeing services for visiting the Ashtavinayak temples. Explore each temple with the guidance of our experienced drivers who can also help you with the local attractions.',
          },
          {
            question: 'What is the luggage allowance for a Pune to Ashtavinayak cab?',
            answer: 'Our vehicles can comfortably accommodate standard luggage. If you have more luggage or specific requirements, please inform us during the booking process, and we’ll make the necessary arrangements.',
          },
          {
            question: 'Is S9 Travels available for corporate or group travel to Ashtavinayak?',
            answer: 'Yes, we offer corporate and group travel services to Ashtavinayak. Whether it’s for a religious group visit or a corporate outing, we ensure a comfortable and enjoyable experience for everyone.',
          },
          {
            question: 'Why should I choose S9 Travels for my Pune to Ashtavinayak journey?',
            answer: 'S9 Travels guarantees a reliable, comfortable, and affordable journey with professional drivers, well-maintained vehicles, and excellent customer service. We prioritize your safety and comfort, ensuring a smooth and memorable trip to the Ashtavinayak temples.',
          },
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Prakash Joshi',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“I booked a cab with S9 Travels for my Ashtavinayak pilgrimage. The driver was very courteous, and the vehicle was clean and comfortable. The journey was smooth, and I felt safe throughout the trip. Highly recommend S9 Travels for your spiritual journeys!”',
        },
        {
          name: 'Mrs. Nisha Patel',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“Our visit to the Ashtavinayak temples was fantastic, thanks to S9 Travels. The vehicle was spacious, and the driver was knowledgeable about the routes and temples. We had a peaceful and enjoyable trip. Will definitely choose S9 Travels again!”',
        },
      ];
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];



      const productSchema = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Pune to Ashtavinayak Cab",
        "description": "Book reliable and affordable Pune to Ashtavinayak cab services with S9 Travels. Whether you need a one-way trip, round-trip, or a luxury car for your Ashtavinayak darshan, we provide comfortable and safe transport with experienced drivers. Perfect for pilgrimage tours, group travel, and family trips to Ashtavinayak temples from Pune.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.9",
          "ratingCount": "8569"
        }
      };
      

      
    return (
        <div>
       <Helmet>
        <title>Pune to Ashtavinayak Cab | Affordable Pilgrimage Cabs | S9 Travels</title>
        <meta 
          name="description" 
          content="Book your Pune to Ashtavinayak cab with S9 Travels for a comfortable and affordable pilgrimage tour. Choose from one-way, round-trip, or luxury cabs for your Ashtavinayak temple visit. Safe, reliable, and convenient travel with experienced drivers." 
        />
        
        {/* Inject JSON-LD Schema */}
        <script type="application/ld+json">
          {JSON.stringify(productSchema)}
        </script>
      </Helmet>

<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/31.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetoashtavinayakcabservice;